"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var route_1 = __importDefault(require("@/Modules/Misc/route"));
var toastNotification_1 = __importDefault(require("@/Modules/Misc/toastNotification"));
var lodash_1 = __importDefault(require("lodash"));
var vue_property_decorator_1 = require("vue-property-decorator");
var PaymentFormPageSubmitButton = /** @class */ (function (_super) {
    __extends(PaymentFormPageSubmitButton, _super);
    function PaymentFormPageSubmitButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.beforeSubmitDialog = false;
        _this.processing = false;
        return _this;
    }
    PaymentFormPageSubmitButton.prototype.onFormSubmitToggle = function (value) {
        if (value) {
            if (this.processing && this.submitEnabled) {
                this.beforeSubmit();
            }
            this.$emit("submit-processed");
        }
    };
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "creditCardFilled", {
        get: function () {
            return (this.computedForm.creditCardNumber.length >= 15 &&
                this.computedForm.creditCardCVV.length >= 3 &&
                this.computedForm.creditCardExpMonth &&
                this.computedForm.creditCardExpYear);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "billingAddressFilled", {
        get: function () {
            return this.addressIsFilled(this.computedForm.billingAddress);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "shippingAddressFilled", {
        get: function () {
            if (this.computedForm.billingIsSameAsShippingAddress) {
                return true;
            }
            return this.addressIsFilled(this.computedForm.billingAddress);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "initialDetailsFilled", {
        get: function () {
            var form = lodash_1.default.cloneDeep(this.computedForm);
            return !!(form.billingFirstName &&
                form.billingLastName &&
                form.billingEmail &&
                form.billingPhone);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "submitEnabled", {
        get: function () {
            if (this.multiple) {
                return (this.initialDetailsFilled &&
                    this.creditCardFilled &&
                    this.billingAddressFilled &&
                    this.shippingAddressFilled &&
                    this.form.selected.length > 0);
            }
            return (this.initialDetailsFilled &&
                this.creditCardFilled &&
                this.billingAddressFilled &&
                this.shippingAddressFilled);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "totalCost", {
        get: function () {
            var bids = this.form.selected.map(function (x) { return x.highest_bid_amount; });
            return lodash_1.default.sum(bids);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PaymentFormPageSubmitButton.prototype, "computedForm", {
        get: function () {
            var form = lodash_1.default.cloneDeep(this.form);
            form.billingAddressString = this.addressString(form.billingAddress);
            if (form.billingIsSameAsShippingAddress) {
                form.shippingAddress = lodash_1.default.clone(form.billingAddress);
            }
            form.shippingAddressString = this.addressString(form.shippingAddress);
            form.creditCardNumber = form.creditCardNumber.replaceAll(" ", "");
            form.totalCost = this.totalCost;
            form.totalCostCurrencyString = this.formatCurrency(this.totalCost);
            form.userId = this.user.id;
            return form;
        },
        enumerable: false,
        configurable: true
    });
    PaymentFormPageSubmitButton.prototype.beforeSubmit = function () {
        var _this = this;
        this.beforeSubmitDialog = true;
        this.$nextTick(function () {
            setTimeout(function () { var _a, _b; return (_b = (_a = _this.$refs.submitBtn) === null || _a === void 0 ? void 0 : _a.$el) === null || _b === void 0 ? void 0 : _b.focus(); });
        });
    };
    PaymentFormPageSubmitButton.prototype.handleSubmit = function () {
        var self = this;
        this.processing = true;
        this.computedForm.post((0, route_1.default)("payment.store"), {
            onSuccess: function (response) {
                var flash = response.props.flash;
                (0, toastNotification_1.default)(self.$toast, flash.message, flash.messageColor);
                self.processing = false;
                self.beforeSubmitDialog = false;
            },
            onError: function (error) {
                console.log(error);
                self.processing = false;
                self.beforeSubmitDialog = false;
            },
        });
    };
    PaymentFormPageSubmitButton.prototype.addressString = function (address) {
        return address.street2
            ? "".concat(address.street, " (").concat(address.street2, "), ").concat(address.city, ", ").concat(address.state, " ").concat(address.zip)
            : "".concat(address.street, ", ").concat(address.city, ", ").concat(address.state, " ").concat(address.zip);
    };
    PaymentFormPageSubmitButton.prototype.addressIsFilled = function (address) {
        return !!(address.street &&
            address.city &&
            address.state &&
            address.zip);
    };
    PaymentFormPageSubmitButton.prototype.formatCurrency = function (number) {
        var formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });
        return formatter.format(number);
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            required: true,
            type: Object,
        })
    ], PaymentFormPageSubmitButton.prototype, "form", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            required: true,
            type: Boolean,
        })
    ], PaymentFormPageSubmitButton.prototype, "multiple", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            required: true,
            type: Object,
        })
    ], PaymentFormPageSubmitButton.prototype, "user", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({
            required: false,
            type: Boolean,
        })
    ], PaymentFormPageSubmitButton.prototype, "formSubmit", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)('formSubmit')
    ], PaymentFormPageSubmitButton.prototype, "onFormSubmitToggle", null);
    PaymentFormPageSubmitButton = __decorate([
        vue_property_decorator_1.Component
    ], PaymentFormPageSubmitButton);
    return PaymentFormPageSubmitButton;
}(vue_property_decorator_1.Vue));
exports.default = PaymentFormPageSubmitButton;
